module.exports = __webpack_public_path__ + "img/ao.c4defe74.svg";